import * as React from 'react';
import { Views } from '../../../abstract';
import { ProjectViews } from '../../abstract';

interface IDashboardBenefitAddEditViewProps extends Interfaces.IViewProps {
    onSave: () => void
}

class DashboardBenefitAddEditView<P, S> extends ProjectViews.CommonView<P & IDashboardBenefitAddEditViewProps, S> {

    constructor(props: any) {
        super(props);
    }

    public validateForm() {
        const { onSave } = this.props;
        const { model } = this.state;
        if (model['title'].ru && model['title'].en) {
            if (model['description'].ru && model['description'].en) {
                if (model['image'].ru) {
                    onSave();
                } else {
                    this.setState({ error: 'Загрузите изображение для русского языка!' } as any)
                }
            } else {
                this.setState({ error: 'Заполните описание на обоих языке!' }  as any)
            }
        } else {
            this.setState({ error: 'Заполните заголовок на обоих языке!' }  as any)
        }
    }

    public renderFullWidthSide() {
        const { model, languageTabValue } = this.state;
        return (
            <React.Fragment>
                <Views.TextField
                    floatingLabelText="Наименование"
                    fullWidth={true}
                    name="name"
                    data-field-type={true}
                    value={model['name']}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.TextField
                    floatingLabelText="Заголовок"
                    fullWidth={true}
                    name="title"
                    value={model['title'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.Dropzone
                    file={model['image'][languageTabValue]}
                    onDrop={(files: any) => this.onDropImage(files)}
                    multiple={false}
                    onClear={() => this.onDropImage()}
                    accept="image/*"
                />
                <Views.TextField
                    floatingLabelText="Мета-описание изображения"
                    fullWidth={true}
                    name="image alt"
                    value={model['image']['alt'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.TextField
                    floatingLabelText="Описание (не более 550 символов)"
                    fullWidth={true}
                    multiLine={true}
                    maxlength="550"
                    name="description"
                    value={model['description'] && model['description'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />

            </React.Fragment>
        )
    }
}

export default DashboardBenefitAddEditView;



// WEBPACK FOOTER //
// ./src/app/dashboard/benefits/addedit/BenefitsAddEditView.tsx